import React from 'react';
import { StickerDesignId } from '../utils/Primitives';
import { useServerStickerResourceCheck } from '../utils/useServerResourceCheck';
import type { ResourceCheckResult } from '../utils/useServerResourceCheck';

export interface StickerResourceTrackerProps {
  stickerId: StickerDesignId;
  onComplete?: (result: ResourceCheckResult) => void;
  onError?: (result: ResourceCheckResult) => void;
  onUpdate?: (result: ResourceCheckResult) => void;
}

export const StickerResourceTracker: React.FC<StickerResourceTrackerProps> = ({
  stickerId,
  onComplete,
  onError,
  onUpdate
}) => {
  const { result } = useServerStickerResourceCheck(Number(stickerId), {
    enabled: true,
    onComplete,
    onError
  });

  React.useEffect(() => {
    if (result && onUpdate) {
      onUpdate(result);
    }
  }, [result, onUpdate]);

  React.useEffect(() => {
    console.log('🎬 StickerResourceTracker mounted for sticker', stickerId);
  }, [stickerId]);

  return null;
};

export interface MultiStickerResourceTrackerProps {
  stickerIds: StickerDesignId[];
  onStickerComplete?: (
    stickerId: StickerDesignId,
    result: ResourceCheckResult
  ) => void;
  onStickerError?: (
    stickerId: StickerDesignId,
    result: ResourceCheckResult
  ) => void;
  onStickerUpdate?: (
    stickerId: StickerDesignId,
    result: ResourceCheckResult
  ) => void;
}

export const MultiStickerResourceTracker:
  React.FC<MultiStickerResourceTrackerProps> = ({
    stickerIds,
    onStickerComplete,
    onStickerError,
    onStickerUpdate
  }) => {
  return (
    <>
      {stickerIds.map(stickerId => (
        <StickerResourceTracker
          key={stickerId}
          stickerId={stickerId}
          onComplete={
            onStickerComplete ? (r) => onStickerComplete(stickerId, r) : undefined
          }
          onError={
            onStickerError ? (r) => onStickerError(stickerId, r) : undefined
          }
          onUpdate={
            onStickerUpdate ? (r) => onStickerUpdate(stickerId, r) : undefined
          }
        />
      ))}
    </>
  );
};


